import React from 'react';
import AboutUs from '../components/Header/AboutUs';
export default function AboutUsPage() {
  return (
    <>
      <AboutUs />
    </>
  );
}
